import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0ff610"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import {computed} from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LocalLoader',
  props: {
    percentLoaded: null
  },
  setup(__props: any) {

const props = __props as {
    percentLoaded: number
  };

_useCssVars(_ctx => ({
  "12e71b91": (_unref(cssWidth))
}))

  

  const cssWidth = computed(() => {
    return `${props.percentLoaded}%`
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["local-loader", {'is-loading': props.loading}])
  }, _hoisted_2, 2))
}
}

})